module.exports = __webpack_public_path__ + "img/part4-item-bg-over1.d8cc6836.png";